import namespace from '../namespace';
import name from './name';

export default [...namespace, name];
